"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const InputError = props => {
  if (!props.error) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "p-1 alert alert-danger",
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "alert-message"
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeRegularSvgIcons.faBell,
    fixedWidth: true
  }), " ", props.error)));
};
var _default = InputError;
exports.default = _default;